import { render, staticRenderFns } from "./Manpower.vue?vue&type=template&id=a50b1ea8&"
import script from "./Manpower.vue?vue&type=script&lang=js&"
export * from "./Manpower.vue?vue&type=script&lang=js&"
import style0 from "./Manpower.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Manpower.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VCardTitle,
  VDataTable,
  VDialog,
  VFlex,
  VIcon,
  VImg,
  VLayout,
  VSpacer,
  VToolbar,
})
